(() => {
  if (customElements.get('rks-customizer')) return;
  const escape = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  class RickysCustomizer extends HTMLElement {
    async connectedCallback() {
      if (this.loaded) return;
      this.loaded = true;
      this.style.display = 'block';
      try {
        const source = new URL(this.dataset.source, location.href);
        const response = await fetch(source);
        if (!response.ok) throw new Error('Failed to load customizer');
        const data = await response.json();
        if (!this.isConnected) { this.loaded=false; return; }
        if (!['swarovski','suede'].includes(data.kind)) throw new Error('Invalid component');
        const assets = new URL('.',source).href;
        const frame = document.createElement('iframe');
        frame.title = data.title;
        frame.style.cssText = 'display:block;border:0;width:100%;height:400px;background:#fff;';
        this.frame = frame;
        this.handleMessage = event => {
          if (event.source !== frame.contentWindow || event.origin !== location.origin || event.data?.channel !== 'rickys-customizer-v1') return;
          const message = event.data;
          if (message.type === 'height' && !this.modal && Number.isFinite(message.height)) frame.style.height = Math.max(100,Math.min(message.height,60000))+'px';
          if (message.type === 'selection') {
            this.selection = message.selection;
            this.dispatchEvent(new CustomEvent('rks:selection',{bubbles:true,detail:{...message.selection}}));
          }
          if (message.type === 'anchor' && Number.isFinite(message.top)) {
            window.scrollTo({top:window.scrollY+frame.getBoundingClientRect().top+message.top-16,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
          }
          if (message.type === 'modal') this.setModal(Boolean(message.open));
        };
        window.addEventListener('message',this.handleMessage);
        const mode=this.dataset.mode==='embedded'?'embedded':'standalone';
        const styles=`body{display:flow-root}body[data-mode="embedded"] .brand,body[data-mode="embedded"] .masthead,body[data-mode="embedded"] .page-intro,body[data-mode="embedded"] picture.hero,body[data-mode="embedded"] .back-top,body[data-mode="embedded"] .note-area{display:none}body[data-mode="embedded"] .hero{padding-top:0}body[data-mode="embedded"] .hero h1{display:none}body[data-mode="embedded"] .color-nav-anchor{margin-bottom:24px}.rks-hidden{display:none!important}`;
        frame.srcdoc = `<!doctype html><html lang="ja"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><link rel="stylesheet" href="${escape(assets+'rks-'+data.kind+'.css')}"><style>${styles}</style></head><body data-kind="${data.kind}" data-mode="${mode}" data-parent-origin="${escape(location.origin)}">${data.body.replaceAll('__ASSETS__',assets)}<script src="${escape(assets+'rks-'+data.kind+'.js')}"></script><script src="${escape(assets+'rks-frame-bridge.js')}"></script></body></html>`;
        this.replaceChildren(frame);
      } catch (error) {
        this.loaded=false;
        const message=document.createElement('p');message.setAttribute('role','alert');message.textContent='見本を読み込めませんでした。再読み込みしてお試しください。';this.replaceChildren(message);
        console.error('Rickys customizer',error);
      }
    }
    setModal(open) {
      if(open===Boolean(this.modal))return;
      this.modal=open;
      if(open){
        this.originalFrameStyle=this.frame.style.cssText;
        this.originalOverflow=document.documentElement.style.overflow;
        document.documentElement.style.overflow='hidden';
        this.frame.style.cssText='position:fixed;inset:0;width:100%;height:100dvh;border:0;background:transparent;z-index:2147483646;';
      }else{
        this.frame.style.cssText=this.originalFrameStyle;
        document.documentElement.style.overflow=this.originalOverflow;
      }
    }
    getSelection(){ return this.selection ? {...this.selection}:null; }
    disconnectedCallback(){
      if(this.modal)this.setModal(false);
      if(this.handleMessage)window.removeEventListener('message',this.handleMessage);
      this.loaded=false;
    }
  }
  customElements.define('rks-customizer',RickysCustomizer);
})();

